import { render } from "./PackingListPage.vue?vue&type=template&id=26f2d3a8&scoped=true&ts=true"
import script from "./PackingListPage.vue?vue&type=script&lang=ts"
export * from "./PackingListPage.vue?vue&type=script&lang=ts"

import "./PackingListPage.vue?vue&type=style&index=0&id=26f2d3a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26f2d3a8"]])

export default __exports__